import React from "react";
import { Result, Button, Icon } from "antd";

const names = {
  P: "protanotopia",
  D: "deuteranotopia",
  T: "tritanotopia"
};

const descriptions = {
  N: `Suas respostas nos dizem que você identifica corretamente cores
     indistiguíveis para as formas mais comuns de daltonismo.`,
  P: "Pessoas com protanotopia tem dificuldade em distinguir a cor vermelha",
  D: "Pessoas com deuteranotopia tem dificuldade em distinguir a cor verde",
  T: "Pessoas com deuteranotopia tem dificuldade em distinguir a cor azul",
  I:
    "As respostas fornecidas não sugerem existência das formas mais comuns de daltonismo ou funcionamento total da visão"
};

export function ResultDesc({ type, onRetake }) {
  let title;
  switch (type) {
    case "N":
      title = "Você provavelmente não possui daltonismo!";
      break;
    case "P":
    case "D":
    case "T":
      title = `Você provavelmente possui ${names[type]}`;
      break;
    default:
      title = "Não foi possível chegar a uma conclusão ";
      break;
  }

  const status = type === "I" ? "warning" : "info";
  return (
    <Result
      title={title}
      status={status}
      subTitle={descriptions[type]}
      {...(type === "N" && { icon: <Icon type="smile" theme="twoTone" /> })}
      extra={[
        <Button key="1" type="primary" onClick={onRetake}>
          Refazer
          <Icon type="form" />
        </Button>
      ]}
    ></Result>
  );
}
